import React, { PureComponent } from 'react';
import './index.scss'
import { Toast } from 'antd-mobile';
import { getVerifycode, reg, queryActStatus, loggedCoupon } from '@/services/api';
import _ from 'lodash';
class RegForm extends PureComponent {
  state = {
    mobile: '',
    verifyCode: '',
    timeCount: 0,
    loading: false,
    isLogin: false,
  }

  async componentDidMount() {
    const token = await window.crgt.getToken();
    if(token){
      const { routerSuccess, handleChangePage } = this.props
      const res = await queryActStatus();
      if(res.code === 0){
        if(res.data.status === 1){
          handleChangePage(routerSuccess, res.data);
          return;
        }
      }
    }
    this.setState({
      loading: true,
      isLogin: !!token,
    });
  }

  async submitWithoutLogin() {
    const res = await loggedCoupon({});
    const { routerSuccess, handleChangePage } = this.props
    if (res.code === 0 && _.has(res, 'data')) {
      if (_.has(res.data, 'prizes')) {
        handleChangePage && handleChangePage(routerSuccess, res.data)
      } else {
        return;
      }
    }
  }

  countDown = () => {
    const task = setInterval(() => {
      const { timeCount } = this.state;
      if (timeCount === 0) {
        clearInterval(task);
      } else {
        this.setState({
          timeCount: timeCount - 1,
        });
      }
    }, 1000);

  }

  getCode = async () => {
    const { timeCount, mobile } = this.state;
    if (!(/^1[3456789]\d{9}$/.test(mobile))) {
      Toast.fail('手机号格式错误', 1);
      return false;
    }
    if (timeCount === 0) {
      this.setState({
        timeCount: 60,
      }, this.countDown);
      const res = await getVerifycode({ mobile });
      if (res.code === 0) {
        Toast.success('验证码已发送', 1);
      }
    }
  }

  submit = async () => {
    const { mobile, verifyCode, isLogin } = this.state;
    if (isLogin) {
      return this.submitWithoutLogin();
    }
    const { regCondition, condition, routerSuccess, handleChangePage, routerFail } = this.props
    if (!(/^1[3456789]\d{9}$/.test(mobile))) {
      Toast.fail('手机号格式错误', 1);
      return false;
    }
    if (verifyCode.length === 0) {
      Toast.fail('请输入验证码', 1);
      return false;
    }
    let res = {};
    res = await reg({
      login: {
        mobile,
        verifyCode,
        // channelId: window.localStorage.getItem('CARHAILING_H5_CHANNELID'),
        // corpId: window.localStorage.getItem('CARHAILING_H5_CHANNELID'),
      }
    });
    if (res.code === 0) {
      window.localStorage.setItem('_ACCESSTOKEN_',res.data.token);
      window.localStorage.setItem('CRGT_TOKEN',res.data.token);
      if(res.data.status === 0 || res.data.status === 1){
        handleChangePage && handleChangePage(routerSuccess, res.data)
      }else{
        Toast.info(res.data.message);
      }
    }
  }

  render() {
    const { mobile, verifyCode, timeCount, isLogin, loading } = this.state;
    const {
      background,
      titleBg,
      labelColor,
      input1Label,
      input2Label,
      inputBgColor,
      vcodeBgColor,
      input1Tip,
      input2Tip,
      vcodeColor,
      inputColor, buttonBgColor, buttonColor, style } = this.props;
    if(!loading)return null;
    return (
      <div className="login-form" style={{ ...style, background: background, }}>
        <div className="login-form-title" style={{ backgroundImage: `url(${titleBg})` }} />
        {!isLogin && (
          <>
            <div className="form-item">
              <div className="label" style={{ color: labelColor }}>{input1Label}</div>
              <input maxLength="11" style={{ background: inputBgColor, color: inputColor }}
                placeholder={input1Tip}
                value={mobile}
                onChange={(e) => { this.setState({ mobile: e.target.value }); }}
              />
            </div>
            <div className="form-item">
              <div className="label" style={{ color: labelColor }}>{input2Label}</div>
              <input maxLength="6" style={{ background: inputBgColor, color: inputColor }}
                className="has-btn"
                placeholder={input2Tip}
                value={verifyCode}
                onChange={(e) => { this.setState({ verifyCode: e.target.value }); }}
              />
              <button
                className="time"
                style={{ background: vcodeBgColor, color: vcodeColor }}
                type="button"
                onClick={this.getCode}
              >
                {timeCount === 0 ? '获取验证码' : `${timeCount}s`}
              </button>
            </div>
          </>
        )}
        <button
          className="submit"
          style={{ background: buttonBgColor, color: buttonColor, marginTop: isLogin ? '10vw' : '4vw' }}
          type="button"
          onClick={this.submit}
        >
          立即领取
      </button>
      </div>
    )
  }

}

export default RegForm;